import { render, staticRenderFns } from "./ViewSelector.vue?vue&type=template&id=35dd796b&"
import script from "./ViewSelector.vue?vue&type=script&lang=js&"
export * from "./ViewSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports